import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import NumberOfRunsPopupDetails from './NumberOfRunsPopupDetails.vue'

export const NumberOfRunsPopup = new PopupBuilder('Number of Runs')
  .appendBody(NumberOfRunsPopupDetails)
  .build()
